module.exports = __webpack_public_path__ + "img/TZ.f14a27c1.svg";